import React from 'react';
import { Zap, MapPin, Bell, BarChart2 } from 'react-feather';
import './WelcomeScreen.css';

interface WelcomeScreenProps {
  onComplete: () => void;
  onSkip?: () => void;
}

export const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onComplete, onSkip }) => {
  return (
    <div className="welcome-content">
      {/* Stepper */}
      <div className="onboarding-header">
        <div className="stepper">
          <div className="stepper-step active">
            <div className="stepper-dot">1</div>
            <span className="stepper-label">Welcome</span>
          </div>
          <div className="stepper-line" />
          <div className="stepper-step">
            <div className="stepper-dot">2</div>
            <span className="stepper-label">Zone</span>
          </div>
          <div className="stepper-line" />
          <div className="stepper-step">
            <div className="stepper-dot">3</div>
            <span className="stepper-label">Setup</span>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="welcome-main">
        <div className="welcome-hero">
          <div className="welcome-icon">
            <Zap size={32} />
          </div>
          <h1 className="app-name">Welcome to TowApp</h1>
          <p className="app-description">
            Stay informed about traffic incidents in the areas that matter to you
          </p>
        </div>

        <div className="features">
          <div className="feature-card">
            <div className="feature-icon">
              <MapPin size={20} />
            </div>
            <div className="feature-content">
              <h3>Set Your Zones</h3>
              <p>Monitor specific areas for incidents</p>
            </div>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <Bell size={20} />
            </div>
            <div className="feature-content">
              <h3>Instant Alerts</h3>
              <p>Get notified when incidents occur</p>
            </div>
          </div>

          <div className="feature-card">
            <div className="feature-icon">
              <BarChart2 size={20} />
            </div>
            <div className="feature-content">
              <h3>Real-time Data</h3>
              <p>Live updates from traffic sources</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="welcome-footer">
        <button className="get-started-btn" onClick={onComplete}>
          Get Started
        </button>
        {onSkip && (
          <button className="skip-btn" onClick={onSkip}>
            I've done this before, skip setup
          </button>
        )}
        <p className="privacy-text">
          Your location data stays on your device
        </p>
      </div>
    </div>
  );
};
